import React, { useState } from "react";
import {
  Button,
  Divider,
  TableAdv,
  PageHeader,
  PageTitle,
} from "../../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../../utils";
import AddPassport from "./PassportAndI94/AddPassport";
import ViewPassport from "./PassportAndI94/ViewPassport";
import AddI94 from "./PassportAndI94/AddI94";
import ViewI94 from "./PassportAndI94/ViewI94";

const PassportAndI94 = () => {
  const [addPassport, setAddPassport] = useState(false);
  const [viewPassport, setViewPassport] = useState(false);
  const [selectedPassport, setSelectedPassport] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const [addI94, setAddI94] = useState(false);
  const [viewI94, setViewI94] = useState(false);
  const [selectedI94, setSelectedI94] = useState(null);
  const [editI94, setEditI94] = useState(false);

  const tableData = [
    {
      passportNumber: "P3406692",
      placeOfIssue: "Hyderabad",
      issuedDate: "2024-12-30T00:00:00.000Z",
      expiryDate: "2024-12-30T00:00:00.000Z",
      status: "Active",
      documents: "documents",
    },
  ];
  const columns = [
    {
      key: "passportNumber",
      label: "Passport Number",
      render: (row) => (
        <span
          className="text-info cursor-pointer"
          // onClick={() => setSelectedEmployee(row)}
        >
          {row.passportNumber}
        </span>
      ),
    },
    {
      key: "placeOfIssue",
      label: "Place of Issue",
    },
    {
      key: "issuedDate",
      label: "Issued Date",
      render: (row) => dateFormator(row.issuedDate, "month-day-year"),
    },

    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) => dateFormator(row.expiryDate, "month-day-year"),
    },
    {
      key: "status",
      label: "Status",
    },

    {
      key: "documents",
      label: "Documents",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
            onClick={() => handleEditPassport(row)}
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="link"
            color="black"
            variant="text"
            size="xs"
            onClick={() => setViewPassport(true)}
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  const I94tableData = [
    {
      i94Number: "759131405A3",
      dateOfLastArrival: "2024-12-30T00:00:00.000Z",
      statusExpiryDate: "2024-12-30T00:00:00.000Z",
      priorityDate: "2024-12-30T00:00:00.000Z",
      status: "Active",
      documents: "documents",
    },
    // {
    //   i94Number: "759131405A4",
    //   dateOfLastArrival: "2024-12-30T00:00:00.000Z",
    //   statusExpiryDate: "2024-12-30T00:00:00.000Z",
    //   priorityDate: "2024-12-30T00:00:00.000Z",
    //   status: "Active",
    //   documents: "documents",
    // },
  ];
  const I94columns = [
    {
      key: "i94Number",
      label: "I-94 Number",
      render: (row) => (
        <span
          className="text-info cursor-pointer"
          // onClick={() => setSelectedEmployee(row)}
        >
          {row.i94Number}
        </span>
      ),
    },
    {
      key: "dateOfLastArrival",
      label: "Date of Last Arrival",
      render: (row) => dateFormator(row.dateOfLastArrival, "month-day-year"),
    },
    {
      key: "statusExpiryDate",
      label: "Status Expiry Date",
      render: (row) => dateFormator(row.statusExpiryDate, "month-day-year"),
    },

    {
      key: "priorityDate",
      label: "Priority Date",
      render: (row) => dateFormator(row.priorityDate, "month-day-year"),
    },
    {
      key: "status",
      label: "Status",
    },

    {
      key: "documents",
      label: "Documents",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
            onClick={() => handleEditI94(row)}
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="link"
            color="black"
            variant="text"
            size="xs"
            // onClick={() => setViewI94(true)}
            onClick={() => {
              setSelectedI94(row);
              setViewI94(true);
            }}
          />
        </div>
      ),
    },
  ];
  const I94mappedRows = mapTableRows(I94tableData, I94columns);

  const handleEditPassport = (row) => {
    setSelectedPassport(row);
    setIsEdit(true);
    setAddPassport(true);
  };
  const handleEditI94 = (row) => {
    setSelectedI94(row);
    setEditI94(true);
    setAddI94(true);
  };

  return (
    <div>
      <div className="mt-4">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"PASSPORT DETAIL"} tag="p" />
            </div>
          }
          RightSection={
            <>
              <Button
                title="add"
                size="sm"
                icon={"ADD"}
                iconPosition={"before"}
                onClick={() => setAddPassport(true)}
              />
            </>
          }
        />
        <Divider />
      </div>
      <div className="my-6">
        <TableAdv tableId={`immigration_h1b_h1bview_passporti94_passportdetail`} rows={mappedRows} columns={columns} hideToolBar />
      </div>
      <div className="mt-4">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"I-94 DETAILS"} tag="p" />
            </div>
          }
          RightSection={
            <>
              <Button
                title="Add"
                size="sm"
                icon={"ADD"}
                iconPosition={"before"}
                onClick={() => setAddI94(true)}
              />
            </>
          }
        />
        <Divider />
      </div>
      <div className="my-6">
        <TableAdv tableId={`immigration_h1b_h1bview_passporti94_i94details`} rows={I94mappedRows} columns={I94columns} hideToolBar />
      </div>
      <AddPassport
        isOpen={addPassport}
        onClose={() => {
          setAddPassport(false);
          setIsEdit(false);
          setSelectedPassport(null);
        }}
        isEdit={isEdit}
        initialData={selectedPassport}
      />
      <ViewPassport
        isOpen={viewPassport}
        onClose={() => setViewPassport(false)}
      />

      <AddI94
        isOpen={addI94}
        onClose={() => {
          setAddI94(false);
          setEditI94(false);
          setSelectedI94(null);
        }}
        isEdit={editI94}
        initialData={selectedI94}
      />
      <ViewI94
        isOpen={viewI94}
        onClose={() => {
          setViewI94(false);
          setSelectedI94(null);
        }}
        data={selectedI94}
      />
    </div>
  );
};

export default PassportAndI94;
